// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-details-link[data-v-f6b6abd4]{bottom:0;display:flex;height:100%;position:relative;-webkit-text-decoration:none;text-decoration:none;width:100%}.product-details-link .home-teaser[data-v-f6b6abd4]{display:flex;justify-content:flex-end;padding-bottom:40px;padding-top:40px}.product-details-link .home-teaser .teaser-text[data-v-f6b6abd4]{background:#fff;padding:25px;width:350px;z-index:3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
